module.exports = __webpack_public_path__ + "static/media/life-ring.1025ca20.svg";